import { render, staticRenderFns } from "./glory.vue?vue&type=template&id=a734d2b6&scoped=true"
import script from "./glory.vue?vue&type=script&lang=js"
export * from "./glory.vue?vue&type=script&lang=js"
import style0 from "./glory.vue?vue&type=style&index=0&id=a734d2b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a734d2b6",
  null
  
)

export default component.exports